import MainCategoryMobile from '../components/CategoryNavMobile/mainCategoryMobile';
import { connect } from 'react-redux';

const MainCategoryNavMobile = connect((state) => state)(MainCategoryMobile);

export default MainCategoryNavMobile;
